import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Chapters from "./pages/Chapters";
import ChapterDetail from "./pages/ChapterDetail";
import ThreadDetail from "./pages/ThreadDetail";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Guidance from "./pages/Guidance";
import Reflect from "./pages/Reflect";
import Leaderboard from "./pages/Leaderboard";

function App() {
  return (
    <div className="App min-h-screen flex flex-col" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/chapters" element={<Chapters />} />
              <Route path="/chapters/:number" element={<ChapterDetail />} />
              <Route path="/threads/:id" element={<ThreadDetail />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/guidance" element={
                <ProtectedRoute>
                  <Guidance />
                </ProtectedRoute>
              } />
              <Route path="/reflect" element={
                <ProtectedRoute>
                  <Reflect />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute adminOnly>
                  <Admin />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
